<template>
    <transition name="bounce">
        <div v-show="showFlag" class="food" ref="food">
            <div class="food-content">
                <div class="image-header" :style="heroImgStyle">
                    <img :src="getImgUrl(food.foodImage, 0)" :style="heroImgStyle" />
                    <div class="hero-overlay"></div>
                    <div class="back-btn" @click="hideFood">
                        <mu-icon value="close" size="24"></mu-icon>
                    </div>
                    <div class="hero-title">{{ food.foodName }}</div>
                </div>

                <div class="content">
                    <div class="price-row">
                        <div class="price">
                            <span class="now">{{ Number(food.price * food.actDiscount).toFixed(0) }}
                                <span class="unit">{{ seller.unit }}</span></span>
                            <span class="old" v-if="food.oldPrice">{{ food.price }} {{ seller.unit }}</span>
                        </div>
                        <div class="cartcontrol-wrapper">
                            <cartcontrol :food="food" v-show="food.childIds == null" :add-type="addType"></cartcontrol>
                        </div>
                    </div>
                </div>

                <div class="split" v-show="food.description"></div>

                <div class="info" v-show="food.description">
                    <div class="section-title">
                        <mu-icon value="description" size="18"></mu-icon>
                        <span>{{ $t('buffet.description') || 'Description' }}</span>
                    </div>
                    <div class="text" v-html="food.description"></div>
                </div>

                <div class="info">
                    <div class="section-title">
                        <mu-icon value="edit" size="18"></mu-icon>
                        <span>{{ $t('orderList.remark') }}</span>
                    </div>
                    <div class="remark-box">
                        <textarea rows="3" v-model="food.remark" class="remark-input"></textarea>
                    </div>
                    <div class="taste-chips" v-if="tasteList.length > 0">
                        <span class="taste-chip" :class="{ active: food.remark && food.remark.indexOf(item.tasteName) > -1 }"
                            v-for="(item, index) in tasteList" :key="index" @click="clickTaste(item)">
                            {{ item.tasteName }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import BScroll from 'better-scroll'
import { eventBus } from '../utils/event-bus'
import cartcontrol from '../components/CartControl.vue'
import { formatDate } from '../utils/formatDate'

const ALL = 2

export default {
    props: {
        food: {
            type: Object
        },
        addType: {
            type: Boolean
        }
    },
    data() {
        return {
            showFlag: false,
            selectType: ALL,
            onlyContent: true,
            tasteList: [],
            seller: {},
            configsData: {},
            tableOrderInfo: {}
        }
    },
    computed: {
        // 顶部大图比例：默认 2:1；QrCodeImageRatio 配置为 "1:1"/"3:2"/"4:3"/"16:9" 等时按配置渲染，高度按屏宽等比计算
        heroImgStyle() {
            let ratioW = 2, ratioH = 1;
            const ratio = this.configsData.QrCodeImageRatio;
            if (ratio != null && ratio !== '') {
                const parts = String(ratio).split(':');
                const rw = parseFloat(parts[0]);
                const rh = parseFloat(parts[1]);
                if (rw > 0 && rh > 0) {
                    ratioW = rw;
                    ratioH = rh;
                }
            }
            const width = window.innerWidth || document.documentElement.clientWidth || 375;
            return { height: Math.round(width * ratioH / ratioW) + 'px' };
        }
    },
    mounted() {
        this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
        this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo') || {};
        this.getConfigs();
        this.getFoodTasteList();
    },
    methods: {
        getConfigs() {
            if (!this.tableOrderInfo.restaurantId) {
                return;
            }
            this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200 && response.data) {
                        response.data.forEach((item) => {
                            this.$set(this.configsData, item.configKey, item.configValue);
                        });
                    }
                });
        },
        show() {
            this.showFlag = true
            this.$nextTick(() => {
                if (!this.foodScroll) {
                    this.foodScroll = new BScroll(this.$refs.food, {
                        click: true
                    })
                } else {
                    this.foodScroll.refresh()
                }
            })
        },
        hideFood() {
            this.showFlag = false
        },
        addFirst(event) {
            this.$nextTick(() => {
                eventBus.$emit('addcart', event.target)
            })
            Vue.set(this.food, 'Quantity', 1)
        },
        selecttype(type) {
            this.selectType = type
            this.$nextTick(() => {
                this.foodScroll.refresh()
            })
        },
        content() {
            this.onlyContent = !this.onlyContent
            this.$nextTick(() => {
                this.foodScroll.refresh()
            })
        },
        needShow(type, text) {
            if (this.onlyContent && !text) {
                return false
            }
            if (this.selectType === ALL) {
                return true
            } else {
                return type === this.selectType
            }
        },
        getFoodTasteList() {
            this.$get('QRCodeOrder/GetFoodTasteList', {})
                .then(response => {
                    if (response.code == 200) {
                        this.tasteList = response.data;
                    } else {
                        this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                    }
                });
        },
        getImgUrl(image, w = 0) {
            if (image == undefined || image == 'undefined' || image == null || image == '') {
                return '../static/img/default.png';
            }
            if (w == 0) {
                return this.global.baseUrl + "uploads/" + image
            }
            return this.global.baseUrl + "api/images/" + w + "/" + image
        },
        clickTaste(item) {
            if (!this.food.remark) {
                this.food.remark = item.tasteName;
            } else if (this.food.remark.indexOf(item.tasteName) === -1) {
                this.food.remark = this.food.remark + ', ' + item.tasteName;
            } else {
                this.food.remark = this.food.remark.replace(new RegExp('\\s*' + item.tasteName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ',?\\s*'), '').replace(/^,\\s*/, '').replace(/,\\s*$/, '');
            }
        },
    },
    filters: {
        formatDate(time) {
            let date = new Date(time)
            return formatDate(date, 'yyyy-MM-dd hh:mm')
        }
    },
    components: {
        cartcontrol
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .food {
        max-width: 100%;
        position: fixed;
        width: 100%;
        z-index: 900;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: 48px;
        background: #fff;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    .food.bounce-enter-active {
        -webkit-animation: bounce-in 0.3s;
        animation: bounce-in 0.3s;
    }
    .food.bounce-leave-active {
        animation: bounce-in 0.3s reverse;
    }

    /* ===== Hero Image ===== */
    .food .food-content .image-header {
        position: relative;
        width: 100%;
        height: 360px;
        overflow: hidden;
    }
    .food .food-content .image-header img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 360px;
        object-fit: cover;
    }
    .food .food-content .image-header .hero-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 42%, rgba(0,0,0,0.62) 100%);
    }
    .food .food-content .image-header .hero-title {
        position: absolute;
        bottom: 38px;
        left: 20px;
        right: 20px;
        color: #fff;
        font-size: 22px;
        font-weight: 700;
        letter-spacing: 0.2px;
        text-shadow: 0 2px 8px rgba(0,0,0,0.45);
        line-height: 1.35;
        z-index: 2;
    }

    /* ===== Back Button ===== */
    .food .food-content .back-btn {
        position: absolute;
        top: 14px;
        right: 14px;
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background: rgba(0,0,0,0.4);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 99;
        transition: background 0.2s, transform 0.2s;
    }
    .food .food-content .back-btn:active {
        background: rgba(0,0,0,0.65);
        transform: scale(0.94);
    }

    /* ===== Content ===== */
    .food .food-content .content {
        position: relative;
        z-index: 2;
        margin-top: -24px;
        padding: 18px 20px 16px;
        border-radius: 20px 20px 0 0;
        background: #fff;
        box-shadow: 0 -6px 20px rgba(0,0,0,0.08);
    }
    .food .food-content .content .price-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .food .food-content .content .price {
        font-size: 32px;
        font-weight: 800;
        color: #da5b3a;
        display: flex;
        align-items: baseline;
        line-height: 1.1;
    }
    .food .food-content .content .price .unit {
        font-size: 15px;
        font-weight: 600;
        margin-left: 3px;
    }
    .food .food-content .content .price .old {
        font-size: 14px;
        font-weight: 400;
        color: #a3a9b3;
        background: #f5f6f8;
        border-radius: 8px;
        padding: 2px 8px;
        text-decoration: line-through;
        margin-left: 10px;
    }
    .food .food-content .content .cartcontrol-wrapper {
        flex-shrink: 0;
    }

    /* ===== Split ===== */
    .food .food-content .split {
        height: 1px;
        margin: 0 20px;
        background: #f0f1f3;
    }

    /* ===== Info Section ===== */
    .food .food-content .info {
        padding: 18px 20px;
    }
    .food .food-content .info .section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 15px;
        font-weight: 700;
        color: #2b2f36;
        margin-bottom: 12px;
    }
    .food .food-content .info .section-title .material-icons {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 8px;
        background: rgba(218, 91, 58, 0.1);
        color: #da5b3a;
    }

    /* ===== Rich Text ===== */
    .food .food-content .info .text {
        font-size: 13.5px;
        color: #606770;
        line-height: 1.75;
        padding: 0;
        word-break: break-word;
    }
    .food .food-content .info .text >>> p {
        margin: 0 0 8px;
    }
    .food .food-content .info .text >>> p:last-child {
        margin-bottom: 0;
    }
    .food .food-content .info .text >>> img {
        display: block;
        max-width: 100%;
        height: auto;
        margin: 10px 0;
        border-radius: 12px;
    }
    .food .food-content .info .text >>> ul,
    .food .food-content .info .text >>> ol {
        margin: 8px 0;
        padding-left: 20px;
    }
    .food .food-content .info .text >>> li {
        margin: 4px 0;
    }
    .food .food-content .info .text >>> strong {
        color: #3a3f47;
        font-weight: 600;
    }
    .food .food-content .info .text >>> a {
        color: #da5b3a;
        text-decoration: none;
    }
    .food .food-content .info .text >>> h1,
    .food .food-content .info .text >>> h2,
    .food .food-content .info .text >>> h3,
    .food .food-content .info .text >>> h4 {
        margin: 10px 0 6px;
        font-size: 14px;
        font-weight: 700;
        color: #2b2f36;
    }
    .food .food-content .info .text >>> table {
        width: 100%;
        border-collapse: collapse;
    }
    .food .food-content .info .text >>> td,
    .food .food-content .info .text >>> th {
        padding: 4px 6px;
        border: 1px solid #eef0f3;
    }

    /* ===== Remark ===== */
    .food .food-content .info .remark-box {
        background: #fff;
        border-radius: 14px;
        border: 1.5px solid rgba(218, 91, 58, 0.35);
        box-shadow: 0 2px 10px rgba(218, 91, 58, 0.06);
        transition: border-color 0.2s, box-shadow 0.2s;
        overflow: hidden;
    }
    .food .food-content .info .remark-box:focus-within {
        border-color: #da5b3a;
        box-shadow: 0 0 0 3px rgba(218, 91, 58, 0.12);
    }
    .food .food-content .info .remark-box .remark-input {
        display: block;
        width: 100%;
        box-sizing: border-box;
        border: none;
        outline: none;
        resize: none;
        padding: 10px 14px;
        font-size: 14px;
        line-height: 1.6;
        color: #3a3f47;
        background: transparent;
        font-family: inherit;
    }

    /* ===== Taste Chips ===== */
    .food .food-content .info .taste-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 14px;
    }
    .food .food-content .info .taste-chip {
        display: inline-block;
        padding: 7px 14px;
        font-size: 12.5px;
        color: #5b626c;
        background: #f4f5f7;
        border-radius: 18px;
        cursor: pointer;
        transition: all 0.2s;
        border: 1px solid #e8eaee;
        user-select: none;
    }
    .food .food-content .info .taste-chip:active {
        transform: scale(0.95);
    }
    .food .food-content .info .taste-chip.active {
        color: #fff;
        background: linear-gradient(135deg, #da5b3a, #e8856b);
        border-color: transparent;
        font-weight: 600;
        box-shadow: 0 2px 8px rgba(218, 91, 58, 0.28);
    }

    .food .food-content {
        padding-bottom: 12px;
    }

    /* 小屏适配 */
    @media screen and (max-height: 640px) {
        .food .food-content .image-header,
        .food .food-content .image-header img {
            height: 280px;
        }
        .food .food-content .image-header .hero-title {
            bottom: 32px;
            font-size: 19px;
        }
    }

    @keyframes bounce-in {
        0% {
            -webkit-transform: scale(0.92);
            transform: scale(0.92);
            opacity: 0;
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Food.vue